import styled from 'styled-components';
import { AllieAvatar } from '../../../components/Media/Avatar';
import { AllieText } from '../../../components/Text';
import { AllieSaveOutlineIcon } from '../../../styling/icons';
import { mediaQueries } from '../../../common/mediaQueries';

export const TimeStamp = styled.div<{ isFactoryGPT?: boolean }>`
  margin-top: var(--allie-spacing-xs);
  text-align: ${({ isFactoryGPT }) => (isFactoryGPT ? 'left' : 'right')};
  opacity: 0;
  transition: opacity 0.2s ease;
  white-space: nowrap;
`;

export const ChatResponseContainer = styled.div<{ isFactoryGPT?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isFactoryGPT }) => (isFactoryGPT ? 'flex-start' : 'flex-end')};
  max-width: ${({ isFactoryGPT }) => (isFactoryGPT ? '100%' : '70%')};
  ${({ isFactoryGPT }) => isFactoryGPT && `
    width: -webkit-fill-available;
  `}
  align-self: ${({ isFactoryGPT }) => (isFactoryGPT ? 'flex-start' : 'flex-end')};

  &:hover ${TimeStamp} {
    opacity: 1;
  }

  &.slide-up-animation {
    animation: slideUpFromBottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  @keyframes slideUpFromBottom {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    50% {
      transform: translateY(10px);
      opacity: 0.5;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const HeaderContainer = styled.div<{ isFactoryGPT?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ isFactoryGPT }) => (isFactoryGPT ? 'flex-start' : 'flex-end')};
  gap: var(--allie-spacing-sm);
  width: 100%;
  margin-bottom: 10px;
`;

export const MessageBubble = styled.div<{ isFactoryGPT?: boolean }>`
  width: 100%;
  ${({ isFactoryGPT }) =>
    !isFactoryGPT &&
    `
    background-color: var(--allie-color-secondary-10);
    border-radius: var(--allie-radius-xxl);
    border-bottom-right-radius: 0;
    padding: var(--allie-spacing-md) var(--allie-spacing-lg);
    position: relative;
    margin-bottom: var(--allie-spacing-xs);
    box-sizing: border-box;
  `}
`;

export const ContentNameMessage = styled.div<{ isFactoryGPT?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ isFactoryGPT }) => (isFactoryGPT ? 'flex-start' : 'flex-end')};
  row-gap: var(--allie-spacing-xs);
  overflow-x: clip;
  flex-grow: 1;
  width: 100%;
`;

export const AllieAvatarStyled = styled(AllieAvatar)`
  & > div {
    border: 0.5px solid rgba(0, 0, 0, 0.08);
  }
`;

// const responsiveSize = (baseSize: number, iconSize: number) => `
//   width: ${baseSize}px;
//   height: ${baseSize}px;

//   > div, svg {
//     height: ${iconSize}px;
//     width: ${iconSize}px;
//   }
// `;

// ${responsiveSize(24, 16)}

// @media (min-width: ${desktopXlScreen}) {
//   ${responsiveSize(32, 20)}
// }

// @media (min-width: ${desktopXxlScreen}) {
//   ${responsiveSize(40, 24)}
// }

export const AllieStarsAvatar = styled.div`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`;

export const AllieTextWrapperMessage = styled(AllieText)`
  --font-size-sm: 14px;
  --font-size-md: 16px;
  --font-size-lg: 18px;

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 600;
    margin-top: var(--allie-spacing-xl);
    margin-bottom: var(--allie-spacing-lg);
    color: var(--allie-color-neutral-90);
  }

  h1 {
    font-size: var(--font-size-lg);
    line-height: 1.33333;
    font-weight: 600;
    letter-spacing: 0em;
    margin-top: 0;
    margin-bottom: 0.5rem;
  }
  h2 {
    font-size: var(--font-size-md);
    line-height: 1.4;
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.25rem;
  }
  h3 {
    font-size: var(--font-size-md);
  }
  h4 {
    font-size: var(--font-size-sm);
  }

  /* Primer heading hijo no debe tener margin-top */
  /* Usar :first-child directo Y :nth-child(1) para cubrir ambos casos */
  ion-text *:first-child {
    margin-top: 0 !important;
  }

  p {
    font-size: var(--font-size-md);
    line-height: 1.75;
    font-weight: 400;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    overflow-wrap: break-word;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 1.25rem;
  }

  li {
    margin-bottom: 0.25rem;
    font-size: var(--font-size-md);
    font-weight: 400;
  }

  div:first-child p {
    margin: 0.25rem 0 1rem;
  }
  div:last-child p {
    margin-bottom: 0;
  }

  table:not([data-allie-table]) {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
    margin: var(--allie-spacing-lg) 0;
    display: table;
    font-size: 0.875em;
    line-height: 1.71429;
  }

  table:not([data-allie-table]) thead {
    display: table-header-group;
  }

  table:not([data-allie-table]) tbody {
    display: table-row-group;
  }

  table:not([data-allie-table]) tr {
    display: table-row;
  }

  table:not([data-allie-table]) th,
  table:not([data-allie-table]) td {
    padding-block: calc(var(--allie-spacing-sm) * 2);
    padding-inline: calc(var(--allie-spacing-sm) * 2);
    text-align: start;
    text-indent: 0;
    border: 0 solid;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-color: var(--allie-color-neutral-20);
    display: table-cell;
  }

  table:not([data-allie-table]) th:first-child,
  table:not([data-allie-table]) td:first-child {
    padding-inline-start: 0;
  }
  table:not([data-allie-table]) th:last-child,
  table:not([data-allie-table]) td:last-child {
    padding-inline-end: 0;
  }

  table:not([data-allie-table]) th {
    font-weight: 600;
    line-height: calc(var(--allie-spacing-sm) * 4);
    border-color: var(--allie-color-neutral-30);
  }

  table:not([data-allie-table]) td {
    font-weight: 400;
  }

  table:not([data-allie-table]) tr:last-child td {
    border-bottom-width: 0;
  }

  hr {
    border: 0 solid;
    border-top-width: 1px;
    border-color: var(--allie-color-neutral-30);
    margin-top: calc(var(--allie-spacing-xl) * 1.75);
    margin-bottom: calc(var(--allie-spacing-xl) * 1.75);
    clear: both;
  }

  blockquote {
    border: 0 solid;
    border-inline-start-width: 0.25rem;
    border-inline-start-color: var(--allie-color-neutral-30);
    border-style: solid;
    color: inherit;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5;
    margin: 0;
    margin-bottom: var(--allie-spacing-sm);
    margin-top: 0;
    padding-block: var(--allie-spacing-sm);
    padding-inline-start: calc(var(--allie-spacing-lg) * 1.5);
    position: relative;
  }
`;

export const ThanksFeedbackContainer = styled.div<{ selected?: boolean }>`
  padding: var(--allie-spacing-md) var(--allie-spacing-lg);
  border-radius: var(--allie-radius-3xl);
  border: 1px solid var(--allie-color-neutral-30);
  background-color: ${({ selected }) =>
    selected ? 'var(--allie-color-primary-50)' : 'var(--allie-color-neutral-5)'};
  width: fit-content;
  margin-top: var(--allie-spacing-md);
`;

export const ToolbarActionContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: var(--allie-spacing-md);
`;

export const ActionIconButton = styled.button<{ $filled?: boolean }>`
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
  color: var(--allie-color-neutral-50);

  @media (pointer: fine) {
    &:hover {
      background: var(--allie-color-neutral-10);
      color: var(--allie-color-neutral-90);
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }

  ${({ $filled }) => $filled && `
    svg path:first-child {
      fill: currentColor;
    }
  `}
`;

export const AllieSaveOutlineIconStyled = styled(AllieSaveOutlineIcon)<{
  isSaved?: boolean;
  fontSize?: number;
}>`
  cursor: pointer;
  font-size: ${(props) => props.fontSize}px;
  color: ${({ isSaved }) =>
    isSaved ? 'var(--allie-color-black-90)' : 'var(--allie-color-neutral-30)'};
`;

export const ChatContextFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-xs);
  padding-bottom: var(--allie-spacing-lg);
`;
export const StyledContextFilterItem = styled.div`
  display: flex;
`;

export const StyledContextFilterValue = styled.div`
  display: flex;
  gap: var(--allie-spacing-md);
`;

export const StyledTextContainer = styled.div`
  width: 50px;
`;

export const BubbleMessageFooter = styled.div<{ isFactoryGPT?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: var(--allie-spacing-sm);
  width: 100%;
  margin-top: var(--allie-spacing-xs);
`;

export const BubbleMessageFooterRow = styled.div<{ isFactoryGPT?: boolean }>`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-sm);
  justify-content: ${({ isFactoryGPT }) => (isFactoryGPT ? 'space-between' : 'flex-end')};
  width: 100%;
`;
